import type { CSSProperties } from 'react';
import { Tier0WelcomeUnlockCard } from './Tier0WelcomeUnlockCard';
import { Tier0LockedTierPreviews, type BuildLadderInput } from './tier0LockedTierPreviews';
import type { TierLadderEntry } from '../../../../services/rewards/RewardsService';

interface TierDisplayInfo {
  tierId: string;
  name: string;
  earnRateDescription?: string;
  maxEarningsDescription?: string;
}

interface NextTierDisplayInfo extends TierDisplayInfo {
  componentChecks?: unknown[];
}

interface AboutTiersTier0Props {
  tier: TierDisplayInfo;
  nextTier: NextTierDisplayInfo | null;
  /** Live tier collection for the rungs ABOVE the next one. */
  ladder?: TierLadderEntry[];
  onBack: () => void;
  onLearnMore: () => void;
}

const DISCORD_LINK_STYLE: CSSProperties = {
  color: '#964fff',
  textDecoration: 'underline rgba(150,79,255,0.5)',
  textUnderlineOffset: 2,
  fontSize: 10,
};

/** Tier 0 About Tiers — same unlock story as welcome (card + locked previews). */
export const AboutTiersTier0 = ({ tier, nextTier, ladder = [], onBack, onLearnMore }: AboutTiersTier0Props) => {
  const pageTitle = 'Machine Tier';
  const supportLabel = 'Get help · Discord';
  const supportUrl = 'https://discord.gg/playcast';

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        boxSizing: 'border-box',
        padding: '0 0 14px',
        background: '#0b0618',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          height: 22,
          marginBottom: 12,
          flexShrink: 0,
        }}
      >
        <button
          type="button"
          onClick={onBack}
          style={{
            border: 'none',
            background: 'transparent',
            padding: 0,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            height: 22,
          }}
        >
          <span style={{ margin: 0, color: '#8d8aa8', fontSize: 12, lineHeight: '22px', fontWeight: 700 }}>← Back</span>
        </button>
      </div>

      <div
        className="hr-scroll"
        style={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          width: '100%',
        }}
      >
        <p
          style={{
            margin: 0,
            color: '#cccccc',
            fontSize: 32,
            lineHeight: 1,
            fontWeight: 700,
            textAlign: 'center',
          }}
        >
          {pageTitle}
        </p>

        <Tier0WelcomeUnlockCard onLearnMore={onLearnMore} />

        <Tier0LockedTierPreviews
          nextTier={nextTier}
          ladder={ladder}
          assignedTierId={tier.tierId}
        />
      </div>

      <div
        style={{
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          paddingTop: 8,
          paddingBottom: 4,
        }}
      >
        <a href={supportUrl} target="_blank" rel="noopener noreferrer" style={DISCORD_LINK_STYLE}>
          {supportLabel}
        </a>
      </div>
    </div>
  );
};
